import { createActions, createReducer } from 'reduxsauce';
import { ICustomer } from 'models/Customer';

export const { Types, Creators } = createActions({
  setCustomer: ['data'],
});

const INITIAL_STATE: ICustomer = {};

const setCustomer = (_state = INITIAL_STATE, action: any) => ({
  ...action.data,
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_CUSTOMER as any]: setCustomer,
});
